import { Component, Input } from '@angular/core';
import { Note } from '../../../models/note';


@Component({
    selector: 'app-note-item',
    templateUrl: './note-item.component.html',
    styleUrls: ['./note-item.component.css'],
    standalone: false
})

export class NoteItemComponent {
  @Input() note: Note;
  @Input() clickReplyCallback: Function;
  @Input() parent: Note;
}
